/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class MapFunctionConfigurationModel {
        public mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        public currentFunction: Wars.Domain.Model.Gis.MapFunctionConfiguration;
        public codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        public selectedEsriWherePredicate:string;

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private deleteService: services.DeleteService,
            private systemLevelService:services.SystemLevelService,
            private mapConfigurationId:string) {

            console.log("test");
            mapConfigurationService.getMapConfiguration(mapConfigurationId).then(map => {
                this.mapConfiguration = map;
            });

            systemLevelService.getSystemLevelCodes().then(systemLevel => {
                this.codeGroups = systemLevel.myCodeGroups;
            });
        }

        public addExecuteGisActionWorkflow() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.MapFunctionType.ExecuteGisActionWorkflow);
            this.save(); 
        }

        public addZoomToCodeDropdown() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.MapFunctionType.ZoomToCodeDropdown);
            this.currentFunction.zoomToQueryConfiguration = this.mapConfigurationService.createZoomToQueryConfiguration();
            this.currentFunction.zoomToQueryConfiguration.doZoom = true;
            this.currentFunction.zoomToQueryConfiguration.placeHolderForInput = this.mapConfigurationService
                .createEsriPlaceHolderValue();

            this.save();
        }

        public addTextPlaceholder() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.MapFunctionType.TextPlaceHolder);
            this.save();
        }

        public addGeometrySelection() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.MapFunctionType.SelectGeometry);

            this.currentFunction.drawFeatureConfiguration = this.mapConfigurationService.createDrawFeatureConfiguration();
            this.save();
        }

        public addZoomToTextBox() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.MapFunctionType.ZoomToTextBox);

            this.currentFunction.zoomToQueryConfiguration = this.mapConfigurationService.createZoomToQueryConfiguration();
            this.currentFunction.zoomToQueryConfiguration.doZoom = true;
            this.currentFunction.zoomToQueryConfiguration.placeHolderForInput = this.mapConfigurationService
                .createEsriPlaceHolderValue();

            this.save();
        }


        public addClearDrawing() {
            this.addFunction(Wars.Domain.Model.Codes.Enums.MapFunctionType.ClearAllDrawings);
            this.save();
        }

        private addFunction(functionType: Wars.Domain.Model.Codes.Enums.MapFunctionType) {
            this.currentFunction = this.mapConfigurationService.createMapFunctionConfiguration();

            this.currentFunction.name = "New Function";
            this.currentFunction.showTextInput = false;
            this.currentFunction.type = functionType;

            this.mapConfiguration.mapFunctions.push(this.currentFunction);
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }

        public delete() {
            this.deleteService.deleteWithModalConfirmIfNecessary("MapFunctionConfiguration",
                this.currentFunction.id,
                "Map Function Configuration",() => {
                    this.currentFunction = null;
                });

        }


    }
}